import store from '@/store'
import { Action, config, Module, Mutation, VuexModule } from "vuex-module-decorators";

config.rawError = true

const name = 'dialogs';
if (module.hot) {
    if (store.hasModule(name)) {
        store.unregisterModule(name);
    }
}
@Module({dynamic: true, store, name: name})
export default class Dialogs extends VuexModule {

    selectedScoringDefinitionEdit: ScoringDefinitionEditElement | null = null
    selectedScoringKeyEdit: ScoringDefinitionEditElement | null = null

    selectedViewpointFactorVisibilityEdit: ViewpointFactorVisibilityEditElement | null = null;

    decisionModelResourceScoringDefinitionEdit: string | null = null
    decisionModelResourceScoringKeyEdit: string | null = null

    factorBuilderEdit: FactorBuilderEdit | null = null;

    @Mutation
    setSelectedScoringDefinitionEdit(payload: ScoringDefinitionEditElement | null) {
        this.selectedScoringDefinitionEdit = payload;
    }

    @Mutation
    setSelectedViewpointFactorVisibilityEdit(payload: ViewpointFactorVisibilityEditElement | null) {
        this.selectedViewpointFactorVisibilityEdit = payload;
    }

    @Mutation
    setSelectedScoringKeyEdit(payload: ScoringDefinitionEditElement | null) {
        this.selectedScoringKeyEdit = payload;
    }

    @Mutation
    setDecisionModelResourceScoringDefinitionEdit(payload: string | null) {
        this.decisionModelResourceScoringDefinitionEdit = payload;
    }

    @Mutation
    setDecisionModelResourceScoringKeyEdit(payload: string | null) {
        this.decisionModelResourceScoringKeyEdit = payload;
    }

    @Mutation
    setFactorBuilderEdit(payload: FactorBuilderEdit | null) {
        this.factorBuilderEdit = payload;
    }

    @Action
    async editScoringDefinition(payload: ScoringDefinitionEditElement | null) {
        this.setSelectedScoringDefinitionEdit(payload);
    }

    @Action
    async editViewpointFactorVisibility(payload: ViewpointFactorVisibilityEditElement | null) {
        this.setSelectedViewpointFactorVisibilityEdit(payload);
    }

    @Action
    async editDecisionModelResourceScoringDefinition(resourceId: string | null) {
        this.setDecisionModelResourceScoringDefinitionEdit(resourceId);
    }

    @Action
    async editDecisionModelResourceScoringKey(payload: string | null) {
        this.setDecisionModelResourceScoringKeyEdit(payload);
    }

    @Action
    async editScoringKey(payload: ScoringDefinitionEditElement | null) {
        this.setSelectedScoringKeyEdit(payload);
    }

    @Action
    async createFactor(payload: FactorBuilderEdit | null) {
        this.setFactorBuilderEdit(payload);
    }

}

interface ScoringDefinitionEditElement {
    viewpointId: string,
    resourceId: string
}

interface FactorBuilderEdit {
    factorResourceId?: string,
    parentId?: string
}

interface ViewpointFactorVisibilityEditElement {
    viewpointId: string,
    factorResourceId: string
}